import { createSelector } from 'reselect';
import { TYPES } from './constants';
import { createLoadingSelector } from '../@loadings';
import { createSuccessSelector } from '../@success';
import { createErrorPayloadSelector, createErrorSelector } from '../@errors';
import { ReduxState } from '../types';
import { YardsDataState } from './types';

export const selectYardsData = (state: ReduxState): YardsDataState => state.yardsData;

export const selectYards = createSelector(selectYardsData, ({ yards }) => yards);

export const selectYardsLoading = createLoadingSelector(TYPES.LOAD_YARDS.TYPE);
export const selectYardsSuccess = createSuccessSelector(TYPES.LOAD_YARDS.TYPE);
export const selectYardsError = createErrorSelector(TYPES.LOAD_YARDS.TYPE);

export const selectCreateYardLoading = createLoadingSelector(TYPES.CREATE_YARD.TYPE);
export const selectCreateYardSuccess = createSuccessSelector(TYPES.CREATE_YARD.TYPE);
export const selectCreateYardError = createErrorSelector(TYPES.CREATE_YARD.TYPE);
export const selectCreateYardErrors = createErrorPayloadSelector(TYPES.CREATE_YARD.TYPE);

export const selectDeleteYardLoading = createLoadingSelector(TYPES.DELETE_YARD.TYPE);
export const selectDeleteYardSuccess = createSuccessSelector(TYPES.DELETE_YARD.TYPE);
export const selectDeleteYardError = createErrorSelector(TYPES.DELETE_YARD.TYPE);

export const selectSaveYardLoading = createLoadingSelector(TYPES.SAVE_YARD.TYPE);
export const selectSaveYardSuccess = createSuccessSelector(TYPES.SAVE_YARD.TYPE);
export const selectSaveYardError = createErrorSelector(TYPES.SAVE_YARD.TYPE);
export const selectSaveYardErrors = createErrorPayloadSelector(TYPES.SAVE_YARD.TYPE);
